import { useMemo } from "react";
import { useSyncedResource } from "hooks/useSyncedResource.hook";
import * as SCOPE from "services/sync/scope";
import useInfrastructure from "hooks/useInfrastructure.hook";
import * as quicklyRepliesSync from "services/sync/resources/chat/quicklyReplies.sync";

export function useChatQuicklyReplies({ enabled = true } = {}) {
  const { syncEngine, repositories } = useInfrastructure();
  const repository = repositories.quicklyReplies;

  enabled = enabled;
  const scope = SCOPE.CHAT.QUICKLY_REPLIES;
  const key = useMemo(() => "(all)", []);
  const syncParams = useMemo(() => ({}), []);

  return useSyncedResource({
    enabled,
    scope,
    key,
    cacheFn: ({ scope, key }) => repository.getFromCache(scope, key, () => repository.getAll()),
    syncParams,
    syncFn: quicklyRepliesSync.all,
    syncEngine,
    repository,
    repositories,
    deps: []
  });
}